import React, { Component } from "react";
import { Grid, Paper, Button, Divider, withStyles } from "@material-ui/core";
import clsx from "clsx";
import Navi_Buttons from "../../../components/forms/navi_buttons";
import { withRouter } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import ZwitserseFoto from "../../../components/forms/zwitserse_foto";
import shortfetch from "../../../components/data/fetch";
import CopyModelData from "./button_copy";
import AddNewModel from "./button_add_new";
import LoadingBar from "../../../components/data/loading";
import getBase64Image from "../../../components/forms/Base64_Encode";
import WarningBox from "../../../components/forms/warning_Box";
import CreateInput from "../../../components/form_input_fields";

const styles = {
  paper: {
    padding: 5,
  },
};

class Form_Modellen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: this.props.match.params.id,
      data_array: {},
      isLoading: true,
      select_items_list: {},
    };
  }

  async fetch_data(id) {
    let post_json = {
      id: id,
      type: "model_data",
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    console.log("fetched_data", data.data_array);

    this.setState({
      ori_data_array: JSON.stringify(data.data_array),
      data_array: data.data_array,
      isLoading: false,
      select_items_list: data,
    });
  }

  async save_data() {
    let post_json = {
      type: "save_data",
      data: this.state.data_array,
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    let data = await shortfetch(post_json);

    if (!data.geslaagd) {
      alert("Er is iets fout gegaan tijdens het opslaan.");
    }

    await this.fetch_data(this.state.data_array.ModelID);
  }

  async copyImages() {
    let post_json = {
      type: "copy_images",
      data: this.state.data_array,
      auth: localStorage.getItem("auth"),
    };
    console.log(JSON.stringify(post_json));

    this.setState({
      isLoading: true,
    });

    await shortfetch(post_json, true);

    this.setState({
      isLoading: false,
    });
  }

  componentDidMount() {
    this.fetch_data(this.props.match.params.id);
  }

  AlgemeenArray = [
    {
      name: "Model ID",
      data_key: "ModelID",
      data_type: "input",
      readonly: true,
    },
    {
      name: "Fabrikant",
      data_key: "naam",
      data_type: "autocomplete",
      select_items_name: "Fabrikanten",
      checkvalue: true,
    },
    {
      name: "Artikelnummer Fabrikant",
      data_key: "FabrikantNummer",
      data_type: "input",
    },
    {
      name: "Omschrijving Fabrikant",
      data_key: "FabrikantOmschrijving",
      data_type: "input",
      multiline: true,
    },
    {
      name: "Unimog Constructie Type (serie)",
      data_key: "TypeID",
      data_type: "select",
      select_items_name: "Serie",
    },
    {
      name: "Unimog-typenummer",
      data_key: "ModelnrID",
      data_type: "select",
      select_items_name: "Type",
    },
    {
      name: "Verhouding",
      data_key: "SchaalID",
      data_type: "select",
      select_items_name: "Verhouding",
    },
    {
      name: "Materiaal",
      data_key: "MateriaalID",
      data_type: "select",
      select_items_name: "Materiaal",
    },
    {
      name: "Toepassing",
      data_key: "ToepassingID",
      data_type: "select",
      select_items_name: "Toepassing",
    },
    {
      name: "Gemaakt Van",
      data_key: "GemaaktVan",
      data_type: "input",
    },
    {
      name: "Gemaakt Tot",
      data_key: "GemaaktTot",
      data_type: "input",
    },
    {
      name: "Exportlanden",
      data_key: "Exportlanden",
      data_type: "input",
    },
    {
      name: "Verkoop In Winkel",
      data_key: "VerkoopInWinkel",
      data_type: "select",
      select_items_name: "VerkoopInWinkel",
    },
    {
      name: "Aantal Stuks",
      data_key: "AantalStuks",
      data_type: "input",
    },
    {
      name: "Nummer Aantal Gemaakt",
      data_key: "Nummer_AantalStuks",
      data_type: "input",
    },
    {
      name: "Verzamel Katalogus Nr",
      data_key: "VerzamelKatalogusNr",
      data_type: "input",
    },
  ];

  KenmerkenArray = [
    {
      name: "Wielafstand",
      data_key: "Wielafstand",
      data_type: "select",
      select_items_name: "Wielafstand",
    },
    {
      name: "Uitvoering Cabine",
      data_key: "UitvoeringCabine",
      data_type: "select",
      select_items_name: "UitvoeringCabine",
    },
    {
      name: "Achteruitkijkspiegel",
      data_key: "Achteruitkijkspiegel",
      data_type: "select",
      select_items_name: "Achteruitkijkspiegel",
    },
    {
      name: "Voorruit",
      data_key: "Voorruit",
      data_type: "select",
      select_items_name: "Voorruit",
    },
    {
      name: "Stuur",
      data_key: "Stuur",
      data_type: "select",
      select_items_name: "Stuur",
    },
    {
      name: "Stoelen",
      data_key: "Stoelen",
      data_type: "select",
      select_items_name: "Stoelen",
    },
    {
      name: "Bestuurder",
      data_key: "Bestuurder",
      data_type: "select",
      select_items_name: "Bestuurder",
    },
    {
      name: "Deuren",
      data_key: "Deuren",
      data_type: "select",
      select_items_name: "Deuren",
    },
    {
      name: "Zwaailicht",
      data_key: "Zwaailicht",
      data_type: "select",
      select_items_name: "Zwaailicht",
    },
    {
      name: "Reservewiel",
      data_key: "Reservewiel",
      data_type: "select",
      select_items_name: "Reservewiel",
    },
    {
      name: "Trekhaak",
      data_key: "Trekhaak",
      data_type: "select",
      select_items_name: "Trekhaak",
    },
    {
      name: "Opschriften",
      data_key: "Opschriften",
      data_type: "input",
      multiline: true,
    },
    {
      name: "Kwaliteit",
      data_key: "NieuwStaat",
      data_type: "select",
      select_items_name: "Kwaliteit",
    },
  ];

  KleurenArray = [
    {
      name: "Kleur Algemeen",
      data_key: "KleurGeheleVoertuig",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Cabine",
      data_key: "KleurCabine",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Laadbak",
      data_key: "KleurLaadbak",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Laadbak Binnenzijde",
      data_key: "KleurLaadbakBinnen",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Opbouw",
      data_key: "KleurOpbouw",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Chassis",
      data_key: "KleurChassis",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Velgen",
      data_key: "KleurVelgen",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
    {
      name: "Kleur Banden",
      data_key: "KleurBanden",
      data_type: "autocomplete",
      data_soort: "Kleuren",
      select_items_name: "kleuren",
    },
  ];

  ExtraArray = [
    {
      name: "Eigen opmerkingen",
      data_key: "Opmerkingen",
      data_type: "input",
    },
  ];

  OverigeArray = [
    {
      name: "Ondergrond",
      data_key: "Ondergrond",
      data_type: "input",
    },
    {
      name: "Verpakking",
      data_key: "Verpakking",
      data_type: "select",
      select_items_name: "Verpakking",
    },
    {
      name: "Internet Beschrijving",
      data_key: "InternetBeschrijving",
      data_type: "input",
    },
    {
      name: "InkoopModel",
      data_key: "InkoopModel",
      data_type: "input",
    },
    {
      name: "Nieuwwaarde",
      data_key: "Nieuwwaarde",
      data_type: "input",
    },
    {
      name: "Gekocht op (dd-mm-jjjj)",
      data_key: "GekochtOp",
      data_type: "datum",
    },
    {
      name: "Dubbel (Hoe vaak aanwezig)",
      data_key: "Dubbel",
      data_type: "input",
    },
    {
      name: "Zwiterse Website",
      data_key: "ZwitserseID",
      data_type: "input",
    },
  ];

  AanbouwArray = [
    {
      name: "Toebehoren",
      data_key: "Toebehoren",
      data_type: "input",
    },
    {
      name: "Kleur",
      data_key: "Kleur",
      data_type: "autocomplete",
      select_items_name: "kleuren",
    },
  ];

  SetArray = [
    {
      name: "Model is onderdeel van een set",
      data_key: "PartOfSet",
      data_type: "checkbox",
    },
    {
      name: "set",
      data_key: "ModelSetName",
      data_type: "autocomplete",
      select_items_name: "SetNames",
      multiline: true,
    },
  ];

  Change_Data(key, value) {
    let new_data_array = this.state.data_array;
    console.log("Key: " + key, "Value:" + value);
    new_data_array[key] = value;
    console.log(new_data_array);
    this.setState({ data_array: new_data_array });
  }

  Create_Input(item) {
    const { name } = item;

    return (
      <React.Fragment key={name}>
        <Grid
          container
          alignItems="center"
          style={{
            overflow: "hidden",
            width: "calc(99% - 5px)",
            padding: 5,
          }}
        >
          <Grid item xs={6}>
            {name + ":"}
          </Grid>
          <Grid item xs={6}>
            <CreateInput
              data={item}
              data_array={this.state.data_array}
              Change_Data={this.Change_Data.bind(this)}
              list={this.state.select_items_list}
            />
          </Grid>
        </Grid>
        <Divider></Divider>
      </React.Fragment>
    );
  }

  Change_State = (someArg) => {
    this.fetch_data(someArg);
    this.setState({ isLoading: true });
  };

  Delete_Image(Type, ID, e) {
    confirmAlert({
      title: "Foto verwijderen",
      message: `Weet je zeker dat je de ${Type} foto wilt verwijderen?`,
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            let post_json = {
              type: "delete_image",
              auth: localStorage.getItem("auth"),
              ModelID: ID,
              data: Type,
            };
            console.log(JSON.stringify(post_json));
            fetch("/api/fetch_data.php", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-form-urlencoded",
              },
              body: JSON.stringify(post_json),
            })
              .then((response) => response.json())
              .then((data) => {
                let succes;
                if (data.geslaagd) {
                  succes = "De foto is succesvol verwijderd.";
                } else {
                  succes = "Er is iets fout gegaan tijdens het verwijderen.";
                }
                alert(succes);
                document.getElementById("img" + Type).src =
                  "/media/Model_images/Placeholder.jpg";
              });
          },
        },
        {
          label: "No",
        },
      ],
    });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingBar />;
    }

    const { classes, className } = this.props;
    const { ModelID, ZwitserseID } = this.state.data_array;
    const NaviButtonsWithRouter = withRouter(Navi_Buttons);
    const CopyModelDataWithRouter = withRouter(CopyModelData);
    const AddNewModelWithRouter = withRouter(AddNewModel);

    return (
      <div style={{ marginBottom: 250 }}>
        <WarningBox
          ShowError={
            this.state.ori_data_array === JSON.stringify(this.state.data_array)
          }
        />
        <Grid container>
          <Grid item xs={12} container spacing={1}>
            <Grid item xs={2} container justify="center" alignItems="center">
              <Grid item>
                <CopyModelDataWithRouter
                  Change_State={this.Change_State}
                  max={this.state.select_items_list.total}
                  ModelID={this.state.data_array.ModelID}
                />
              </Grid>
            </Grid>
            <Grid item xs={2} container justify="center" alignItems="center">
              <Grid item>
                <AddNewModelWithRouter
                  Change_State={this.Change_State}
                  max={this.state.select_items_list.total}
                  ModelID={this.state.data_array.ModelID}
                />
              </Grid>
            </Grid>
            <Grid item xs={2} container justify="center" alignItems="center">
              <Grid item>
                <Button
                  onClick={() => this.save_data()}
                  style={{ background: "white" }}
                >
                  Opslaan
                </Button>
              </Grid>
            </Grid>

            <Grid item xs={6}>
              <NaviButtonsWithRouter
                value={this.props.match.params.id}
                Change_State={this.Change_State}
                max={this.state.select_items_list.total}
                ShowColorCalculator={true}
              />
            </Grid>
          </Grid>
          <Grid style={{ paddingLeft: 8 }} item xs={12} container spacing={1}>
            <Grid item xs={4} container direction="column">
              <Grid item>
                <Paper className={clsx(classes.paper)}>
                  <h3>Algemeen</h3>
                  <Divider></Divider>
                  {this.AlgemeenArray.map((item) => {
                    return this.Create_Input(item);
                  })}
                </Paper>
              </Grid>
              <Grid item style={{ marginTop: 8 }}>
                <Paper className={clsx(classes.paper)}>
                  <h3>Extra</h3>
                  <Divider></Divider>
                  {this.ExtraArray.map((item) => {
                    return this.Create_Input(item);
                  })}
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={4} container direction="column">
              <Grid item>
                <Paper className={clsx(classes.paper)}>
                  <h3>Kenmerken</h3>
                  <Divider></Divider>
                  {this.KenmerkenArray.map((item) => {
                    return this.Create_Input(item);
                  })}
                </Paper>
              </Grid>
              <Grid item style={{ marginTop: 8 }}>
                <Paper className={clsx(classes.paper)}>
                  <h3>Set</h3>
                  <Divider></Divider>
                  {this.SetArray.map((item) => {
                    if (
                      item.data_key === "PartOfSet" ||
                      Number(this.state.data_array["PartOfSet"])
                    ) {
                      return this.Create_Input(item);
                    }
                  })}
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={4} container direction="column">
              <Grid item>
                <Paper className={clsx(classes.paper)}>
                  <h3>Kleuren</h3>
                  <Divider></Divider>
                  {this.KleurenArray.map((item) => {
                    return this.Create_Input(item);
                  })}
                </Paper>
              </Grid>
              <Grid item style={{ marginTop: 8 }}>
                <Paper className={clsx(classes.paper)}>
                  <h3>Overige</h3>
                  <Divider></Divider>
                  {this.OverigeArray.map((item) => {
                    return this.Create_Input(item);
                  })}
                </Paper>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper)}>
                <h3>Aanhanger/Aanbouwapparaat</h3>
                <Divider></Divider>
                <Grid container>
                  {this.AanbouwArray.map((item, index) => {
                    return (
                      <Grid item xs={4} key={index}>
                        {this.Create_Input(item)}
                      </Grid>
                    );
                  })}
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper)}>
                <h3>Foto's</h3>
                <Divider></Divider>
                <Grid container justify="center">
                  {[
                    { name: "RechterZijkant", size: 2 },
                    { name: "LinkerZijkant", size: 2 },
                    { name: "VoorKant", size: 2 },
                    { name: "AchterKant", size: 2 },
                    { name: "BovenKant", size: 2 },
                    { name: "OnderKant", size: 2 },
                    { name: "Algemeen", size: 3 },
                    { name: "Set", size: 3 },
                    { name: "Catalogus", size: 3 },
                  ].map((item) => {
                    return (
                      <Grid
                        item
                        xs={item.size}
                        container
                        alignItems="center"
                        style={{
                          overflow: "auto",
                          width: "calc(100% - 5px)",
                          padding: 5,
                        }}
                        key={item.name}
                      >
                        <img
                          src={
                            `/media/Model_images/Model-${ModelID}/${ModelID}-${item.name}_min.jpg?` +
                            new Date().getTime()
                          }
                          style={{
                            width: "100%",
                            borderRadius: 7,
                            border: "black 2px solid",
                          }}
                          onClick={(e) =>
                            this.Delete_Image(item.name, ModelID, e)
                          }
                          onError={(e) => {
                            e.target.onError = null;
                            e.target.src =
                              "/media/Model_images/Placeholder.jpg";
                          }}
                          id={"img" + item.name}
                        ></img>
                        <Grid item xs={6}>
                          {item.name}
                        </Grid>
                        <Grid item xs={6}>
                          <input
                            type="file"
                            id={"imgInput" + item.name}
                            name={item.name}
                            //value={this.state.data_array[data_key]}
                            style={{
                              width: "100%",
                              fontSize: "120%",
                              display: "none",
                            }}
                            onChange={(e) =>
                              getBase64Image(e.target.files[0]).then((value) =>
                                this.Change_Data(item.name, value)
                              )
                            }
                          ></input>
                          <label htmlFor={"imgInput" + item.name}>
                            <Button
                              component="span"
                              className={classes.button}
                              style={{
                                background: "grey",
                              }}
                            >
                              Upload
                            </Button>
                          </label>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
                <Divider></Divider>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper)}>
                <Grid container justify="center" alignItems="center">
                  <Grid
                    item
                    xs={12}
                    container
                    justify="center"
                    alignItems="center"
                  >
                    <Button
                      onClick={() => this.save_data()}
                      style={{ background: "#D3D3D1", width: "80%" }}
                    >
                      Opslaan
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={clsx(classes.paper)}>
                <Grid container justify="center" alignItems="center">
                  <Grid
                    item
                    xs={12}
                    container
                    justify="center"
                    alignItems="center"
                  >
                    <span styl={{ fontSize: "150%" }}>Zwitserse foto</span>
                    <Divider />
                  </Grid>
                  <Grid item xs={3}>
                    {ZwitserseID !== "" ? (
                      <ZwitserseFoto link={ZwitserseID} />
                    ) : (
                      "Er is geen zwitserse foto gevonden."
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={7}
                    container
                    justify="center"
                    alignItems="center"
                  >
                    <Grid item>
                      <Button
                        onClick={() => this.copyImages()}
                        style={{ background: "grey" }}
                      >
                        Foto's van Zwiterse downloaden
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Form_Modellen);
